// itinerarySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Url } from "./url";

export const fetchItineraries = createAsyncThunk(
  "itineraries/fetchItineraries",
  async ({ language, cruiseUrl }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${Url}/api/bookingWedget/getBookingForm/${language}/${cruiseUrl}`
      );
      return response.data; // Assuming the API response format is { data: [...] }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const itinerarySlice = createSlice({
  name: "itineraries",
  initialState: {
    data: [],
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItineraries.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchItineraries.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchItineraries.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default itinerarySlice.reducer;
